import React from 'react'
import image from '../../../assets/homepage_tag.png'
import two from '../../../assets/homepage_pro6.png'
const LowerBannerFour = () => {
    return (
        <>
            <div className="cate-bx4 common">
                <div className="cate-lft">
                    <div className="tag">
                        <img className="img-fluid" src={image} alt="" />
                    </div>
                    <h4>Headphone Ship within 24Hrs</h4>
                    <a href="#" className="btn-buy">
                        Buy Now
                    </a>
                </div>
                <div className="bx-img">
                    <img className="img-fluid" src={two} alt="" />
                </div>
            </div>
        </>
    )
}

export default LowerBannerFour